export default __webpack_public_path__ + "static/media/forged-hub.87312b77.webp";